module.exports = __webpack_public_path__ + "static/img/54.2030cc4e.gif";